/* Renk Sahnesi başlık: küçük yardımcılar. Saf JS, bağımlılık yok.
   Menü düğmesinin aç/kapa işi, açılır panellerin dışarı tıklama ve Escape ile
   kapanması ve sepet sayacının tazelenmesi assets/oyunperest.js'tedir; burası
   yalnız onların üstüne eklenen inceliklerdir (Escape, klavye odağı, menü açıkken
   sabit satın alma çubuğunun çekilmesi, dışarı dokununca menünün kapanması), yukarı
   kaydırınca geri gelen başlık ve yazarken kitap önerisi. Sahne tonu (açık/koyu logo) betiği
   sections/rs-header.liquid içindedir, çünkü sayfa ayrıştırılırken çalışması gerekir. */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';

  function header() {
    return document.querySelector('.rs-header');
  }

  /* Sepet boşken sayaç gizlenir; oyunperest.js metni tazeleyince yeniden görünür */
  function watchCount(root) {
    root.querySelectorAll('[data-op-cart-count]').forEach(function (el) {
      if (el.rsWatched) return;
      el.rsWatched = true;
      var sync = function () {
        el.hidden = (parseInt(el.textContent, 10) || 0) < 1;
      };
      new MutationObserver(sync).observe(el, { childList: true, characterData: true, subtree: true });
      sync();
    });
  }

  function closeDrawer() {
    var root = header();
    if (!root) return null;
    var burger = root.querySelector('[data-op-drawer-toggle][aria-expanded="true"]');
    if (!burger) return null;
    var drawer = document.getElementById(burger.getAttribute('aria-controls') || 'rs-drawer');
    burger.setAttribute('aria-expanded', 'false');
    if (drawer) drawer.hidden = true;
    return burger;
  }

  /* Mobil menü kartı açık ve ekrandayken <html class="rs-menu-acik"> olur; ürün sayfasının
     sabit satın alma çubuğu bu sınıfla çekilir (assets/rs-header.css), kartın üstüne binmez.
     Menü kapanınca ya da kaydırılıp ekrandan çıkınca sınıf kalkar, çubuk geri gelir. */
  function syncMenuState() {
    var drawer = document.getElementById('rs-drawer');
    var open = !!drawer && !drawer.hidden && drawer.getBoundingClientRect().bottom > 0;
    document.documentElement.classList.toggle('rs-menu-acik', open);
  }

  /* Menü klavyeyle açıldıysa odak ilk bağlantıya geçer: yoksa sıradaki dört durak logo,
     arama ve sepettir. Dokunma ve fare tıklamasında odak yerinde kalır. */
  var openedByKeyboard = false;
  document.addEventListener('click', function (event) {
    var toggle = event.target instanceof Element ? event.target.closest('[data-op-drawer-toggle]') : null;
    if (toggle) openedByKeyboard = event.detail === 0;
  }, true);

  /* Aç/kapa işini oyunperest.js yapar; burada yalnız sonucu (hidden özniteliği) izlenir */
  function watchDrawer() {
    var drawer = document.getElementById('rs-drawer');
    if (!drawer || drawer.rsWatched) return;
    drawer.rsWatched = true;
    new MutationObserver(function () {
      syncMenuState();
      if (!drawer.hidden && openedByKeyboard) {
        var first = drawer.querySelector('a[href], summary');
        if (first) first.focus();
      }
      openedByKeyboard = false;
    }).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });
  }

  var menuTick = false;
  function queueMenuState() {
    if (menuTick) return;
    menuTick = true;
    requestAnimationFrame(function () {
      menuTick = false;
      syncMenuState();
    });
  }
  /* Bu temada kaydırma window'da değil .page-wrapper içinde olabilir: capture ile dinlenir */
  document.addEventListener('scroll', queueMenuState, { capture: true, passive: true });
  window.addEventListener('resize', queueMenuState);

  function closeMegas() {
    document.querySelectorAll('.rs-mega[open]').forEach(function (el) {
      el.removeAttribute('open');
    });
  }

  /* Escape mobil menüyü kapatır, odak menü düğmesine döner */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var burger = closeDrawer();
    if (burger) burger.focus();
  });

  /* Klavyeyle panelden çıkılınca açık panel arkada kalmaz */
  document.addEventListener('focusout', function (event) {
    var mega = event.target instanceof Element ? event.target.closest('.rs-mega[open]') : null;
    if (!mega) return;
    var next = event.relatedTarget;
    if (next instanceof Node && !mega.contains(next)) mega.removeAttribute('open');
  });

  /* Ekran genişliği eşiği geçince öbür düzenin açık parçası kapanır */
  var mq = window.matchMedia ? window.matchMedia(DESKTOP) : null;
  if (mq) {
    var onChange = function (event) {
      if (event.matches) closeDrawer();
      else closeMegas();
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  /* Geri tuşuyla önbellekten dönen sayfada menü açık kalmaz */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    closeDrawer();
    closeMegas();
  });

  /* Menü kartı açıkken kartın ve başlığın dışına dokunmak menüyü kapatır (örtü yok:
     kart içeriği aşağı iter, okur kaydırınca menü düğmesi ekrandan çıkabiliyordu). */
  document.addEventListener('click', function (event) {
    var drawer = document.getElementById('rs-drawer');
    if (!drawer || drawer.hidden) return;
    var target = event.target;
    if (!(target instanceof Element) || target.closest('.rs-header')) return;
    closeDrawer();
  });

  /* ------------------------------------------------------------------
     Geri gelen başlık. Durumlar <html> sınıflarıdır (assets/rs-header.css):
       rs-hdr-ust  başlık ekrandan çıktı, sabit ve yukarıda gizli
       rs-hdr-acik okur yukarı kaydırdı, ince çubuk görünür
       rs-hdr-ara  (telefon) ince çubukta arama satırı açık
     --rs-hdr-ust görünen çubuğun yüksekliğidir; yapışkan parçalar onun altına iner.
     ------------------------------------------------------------------ */
  var root = document.documentElement;
  var group = null;
  var lastY = 0;
  var travel = 0;
  var naturalH = 0;
  var scrollTick = false;
  var UP = 12; /* bu kadar yukarı kaydırmadan çubuk gelmez: titrek dokunuşlar başlığı oynatmasın */
  var DOWN = 6;

  /* Kaydıran öğe (masaüstünde .page-wrapper, telefonda pencere) bir kez bulunur ve boyut
     değişince yenilenir: her kaydırma karesinde getComputedStyle çağırmak yerleşim zorluyordu */
  var scroller;
  var scrollerCheckedAt = 0;
  function wrapper() {
    /* Bulunamadıysa (sayfa henüz kısa, kaydırma kilidi açık) saniyede en çok bir kez yeniden
       bakılır: görseller yüklenip sayfa uzayınca .page-wrapper kaydırıcısı yakalanır */
    if (scroller === undefined || (scroller === null && Date.now() - scrollerCheckedAt > 1000)) {
      scrollerCheckedAt = Date.now();
      var w = document.querySelector('.page-wrapper');
      scroller = w && w.scrollHeight > w.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(w).overflowY) ? w : null;
    }
    return scroller;
  }
  function currentY() {
    var w = wrapper();
    return w ? w.scrollTop : window.pageYOffset || document.documentElement.scrollTop || 0;
  }
  function setVisibleHeight() {
    var el = header();
    var h = el && root.classList.contains('rs-hdr-acik') ? el.getBoundingClientRect().height : 0;
    root.style.setProperty('--rs-hdr-ust', Math.round(h) + 'px');
  }
  function pin() {
    var el = header();
    if (!el || !group) return;
    var w = wrapper();
    naturalH = group.offsetHeight;
    group.style.minHeight = naturalH + 'px';
    el.style.setProperty('--rs-hdr-w', (w ? w.clientWidth : document.documentElement.clientWidth) + 'px');
    root.classList.add('rs-hdr-ust');
    /* Geçiş bir kare sonra açılır: sabitlenme anında başlık görünür biçimde yukarı kaymasın */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (root.classList.contains('rs-hdr-ust')) root.classList.add('rs-hdr-anim');
      });
    });
  }
  function unpin() {
    root.classList.remove('rs-hdr-ust', 'rs-hdr-acik', 'rs-hdr-anim', 'rs-hdr-ara');
    if (group) group.style.minHeight = '';
    var find = document.querySelector('[data-rs-find]');
    if (find) find.setAttribute('aria-expanded', 'false');
    setVisibleHeight();
  }
  function hideBar() {
    if (!root.classList.contains('rs-hdr-acik')) return;
    /* Okur başlıktaki arama alanına yazıyorsa çubuk elinden kaçmaz (telefonda klavye açılınca
       sayfa kayabilir) */
    var el = header();
    var focused = document.activeElement;
    if (el && focused && focused.tagName === 'INPUT' && el.contains(focused)) return;
    closeDrawer();
    closeMegas();
    root.classList.remove('rs-hdr-acik', 'rs-hdr-ara');
    var find = document.querySelector('[data-rs-find]');
    if (find) find.setAttribute('aria-expanded', 'false');
    setVisibleHeight();
  }
  function showBar() {
    if (root.classList.contains('rs-hdr-acik')) return;
    root.classList.add('rs-hdr-acik');
    setVisibleHeight();
  }

  function onScroll() {
    scrollTick = false;
    if (!group) return;
    var y = Math.max(0, currentY());
    var dy = y - lastY;
    lastY = y;
    var pinned = root.classList.contains('rs-hdr-ust');
    if (y <= 2) {
      if (pinned) unpin();
      travel = 0;
      return;
    }
    if (!pinned) {
      /* Başlık hâlâ (kısmen) ekrandaysa sayfayla birlikte kayar */
      if (y > group.offsetHeight) {
        /* Menü kartı açıkken başlık sabitlenmez: kart sayfayla birlikte kayıp gider */
        var drawer = document.getElementById('rs-drawer');
        if (drawer && !drawer.hidden) {
          closeDrawer();
          return;
        }
        pin();
      }
      travel = 0;
      return;
    }
    if ((dy > 0 && travel < 0) || (dy < 0 && travel > 0)) travel = 0;
    travel += dy;
    if (travel <= -UP) showBar();
    else if (travel >= DOWN) hideBar();
  }
  function queueScroll() {
    if (scrollTick) return;
    scrollTick = true;
    requestAnimationFrame(onScroll);
  }

  function initBar() {
    var el = header();
    if (!el) return;
    group = document.getElementById('header-group') || el.parentElement;
    lastY = Math.max(0, currentY());
    var find = el.querySelector('[data-rs-find]');
    if (find && !find.rsReady) {
      find.rsReady = true;
      find.hidden = false;
      find.addEventListener('click', function () {
        var open = !root.classList.contains('rs-hdr-ara');
        root.classList.toggle('rs-hdr-ara', open);
        find.setAttribute('aria-expanded', String(open));
        setVisibleHeight();
        if (open) {
          var input = document.getElementById(find.getAttribute('aria-controls'));
          if (input) input.focus();
        }
      });
    }
  }
  document.addEventListener('scroll', queueScroll, { capture: true, passive: true });
  /* Yalnız genişlik değişince sıfırlanır: telefonda klavye ve adres çubuğu yalnız yüksekliği
     değiştirir; o anda sıfırlamak açılan arama satırını ve geri çağrılan çubuğu kapatıyordu */
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    scroller = undefined;
    if (!root.classList.contains('rs-hdr-ust')) return;
    unpin();
    queueScroll();
  });
  /* Sabit çubukta menü kartı açılıp kapanınca görünen yükseklik değişir */
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element) || !event.target.closest('[data-op-drawer-toggle]')) return;
    requestAnimationFrame(setVisibleHeight);
  });

  /* ------------------------------------------------------------------
     Yazarken kitap önerisi: Shopify öngörülü arama (/search/suggest.json).
     Alan bir birleşik kutudur (role=combobox); öneriler kapaklı bir liste. ↑/↓ gezer,
     Enter seçili öneriye gider (seçili yoksa form normal gönderilir), Escape kapatır.
     Uygulama üyelikleri (tip-uygulama) listelenmez. Ayar ve metinler #rs-suggest-config.
     ------------------------------------------------------------------ */
  var suggestSeq = 0;
  function suggestConfig() {
    var el = document.getElementById('rs-suggest-config');
    return el ? el.dataset : null;
  }
  function money(value, cur) {
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    var text = n.toLocaleString('tr-TR', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return cur ? text + ' ' + cur : text;
  }
  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function setupSuggest(form) {
    var cfg = suggestConfig();
    var input = form.querySelector('input[name="q"]');
    if (!cfg || !cfg.url || !input || form.rsSuggest) return;
    form.rsSuggest = true;
    var id = 'rs-suggest-' + (++suggestSeq);

    var box = document.createElement('div');
    box.className = 'rs-suggest';
    box.hidden = true;
    var list = document.createElement('ul');
    list.className = 'rs-suggest__list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    if (cfg.label) list.setAttribute('aria-label', cfg.label);
    var status = document.createElement('p');
    status.className = 'rs-suggest__status';
    status.hidden = true;
    box.appendChild(status);
    box.appendChild(list);
    form.appendChild(box);
    /* Ekran okuyucu duyurusu görsel listeden ayrı: liste kapalıyken de konuşabilir */
    var live = document.createElement('span');
    live.className = 'rs-vh';
    live.setAttribute('role', 'status');
    form.appendChild(live);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', id);

    var timer = 0;
    var loadTimer = 0;
    var controller = null;
    var active = -1;
    var lastQuery = '';

    function options() {
      return list.querySelectorAll('[role="option"]');
    }
    function setActive(index) {
      var opts = options();
      opts.forEach(function (o, i) {
        var on = i === index;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-selected', String(on));
        if (on) o.scrollIntoView({ block: 'nearest' });
      });
      active = index;
      if (index > -1 && opts[index]) input.setAttribute('aria-activedescendant', opts[index].id);
      else input.removeAttribute('aria-activedescendant');
    }
    function open() {
      box.hidden = false;
      input.setAttribute('aria-expanded', String(options().length > 0));
    }
    function close() {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      setActive(-1);
    }
    function showStatus(text, kind) {
      status.textContent = text;
      status.className = 'rs-suggest__status' + (kind ? ' rs-suggest__status--' + kind : '');
      status.hidden = !text;
    }
    function allRow(q) {
      var li = document.createElement('li');
      li.className = 'rs-suggest__opt rs-suggest__opt--all';
      li.id = id + '-all';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      var a = document.createElement('a');
      a.href = form.getAttribute('action') + '?' + new URLSearchParams(new FormData(form)).toString();
      a.tabIndex = -1;
      var t = document.createElement('span');
      t.textContent = (cfg.all || '[arama]').replace('[arama]', q);
      var arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      a.appendChild(t);
      a.appendChild(arrow);
      li.appendChild(a);
      return li;
    }
    function render(q, products) {
      list.textContent = '';
      var cur = cfg.currency || '';
      products.forEach(function (p, i) {
        var li = document.createElement('li');
        li.className = 'rs-suggest__opt';
        li.id = id + '-' + i;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        var a = document.createElement('a');
        a.href = p.url;
        a.tabIndex = -1;
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        if (img) {
          var im = document.createElement('img');
          im.src = sized(img, 120);
          im.alt = '';
          im.width = 40;
          im.height = 50;
          im.loading = 'lazy';
          im.decoding = 'async';
          a.appendChild(im);
        } else {
          var ph = document.createElement('span');
          ph.className = 'rs-suggest__ph';
          a.appendChild(ph);
        }
        var text = document.createElement('span');
        var t = document.createElement('span');
        t.className = 'rs-suggest__t';
        t.textContent = p.title;
        var m = document.createElement('span');
        m.className = 'rs-suggest__m';
        var meta = [];
        if (p.tags && p.tags.indexOf('tip-set') > -1 && cfg.set) meta.push(cfg.set);
        meta.push(money(p.price, cur));
        m.textContent = meta.join(' · ');
        if (parseFloat(p.compare_at_price_max) > parseFloat(p.price)) {
          var was = document.createElement('s');
          was.textContent = money(p.compare_at_price_max, cur);
          m.appendChild(was);
        }
        text.appendChild(t);
        text.appendChild(m);
        a.appendChild(text);
        li.appendChild(a);
        list.appendChild(li);
      });
      list.appendChild(allRow(q));
      setActive(-1);
    }

    function fetchSuggest(q) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      clearTimeout(loadTimer);
      /* Hızlı yanıtta yükleniyor satırı hiç görünmez (titreme olmasın) */
      loadTimer = setTimeout(function () {
        if (lastQuery !== q) return;
        list.textContent = '';
        showStatus(cfg.loading, 'load');
        open();
      }, 250);
      var params = new URLSearchParams();
      params.set('q', q);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '10');
      params.set('resources[options][unavailable_products]', 'last');
      fetch(cfg.url + '.json?' + params.toString(), {
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined,
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (data) {
          if (q !== lastQuery) return;
          clearTimeout(loadTimer);
          var all = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          var tag = cfg.appTag || 'tip-uygulama';
          var products = all.filter(function (p) {
            return !(p.tags && p.tags.indexOf(tag) > -1);
          }).slice(0, 6);
          render(q, products);
          if (products.length) {
            showStatus('', '');
            live.textContent = (cfg.count || '[n]').replace('[n]', products.length);
          } else {
            showStatus(cfg.none, 'none');
            live.textContent = cfg.none || '';
          }
          if (document.activeElement === input) open();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (q !== lastQuery) return;
          clearTimeout(loadTimer);
          list.textContent = '';
          showStatus(cfg.error, 'error');
          live.textContent = cfg.error || '';
          if (document.activeElement === input) open();
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQuery = q;
      clearTimeout(timer);
      if (q.length < 2) {
        if (controller) controller.abort();
        clearTimeout(loadTimer);
        close();
        return;
      }
      timer = setTimeout(function () {
        fetchSuggest(q);
      }, 180);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && input.value.trim() === lastQuery && list.childNodes.length) open();
    });
    input.addEventListener('keydown', function (event) {
      var opts = options();
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (box.hidden) {
          if (opts.length) open();
          else return;
        }
        event.preventDefault();
        var n = opts.length;
        if (!n) return;
        var next = event.key === 'ArrowDown' ? active + 1 : active - 1;
        if (next >= n) next = 0;
        if (next < -1) next = n - 1;
        setActive(next);
      } else if (event.key === 'Enter') {
        if (!box.hidden && active > -1 && opts[active]) {
          event.preventDefault();
          var link = opts[active].querySelector('a');
          if (link) window.location.href = link.href;
        }
      } else if (event.key === 'Escape') {
        if (!box.hidden) {
          /* Yalnız liste kapanır; sayfa düzeyindeki Escape (menü kapatma) çalışmaz */
          event.preventDefault();
          event.stopPropagation();
          close();
        }
      }
    });
    /* Öneriye tıklarken alan odağını kaybetmez (liste tıklamadan önce kapanmasın) */
    box.addEventListener('mousedown', function (event) {
      event.preventDefault();
    });
    form.addEventListener('focusout', function (event) {
      var next = event.relatedTarget;
      if (next instanceof Node && form.contains(next)) return;
      close();
    });
    form.addEventListener('submit', function () {
      close();
    });
  }

  function initSuggest() {
    document.querySelectorAll('form[data-rs-suggest]').forEach(setupSuggest);
  }

  function init() {
    var root = header();
    if (root) watchCount(root);
    watchDrawer();
    syncMenuState();
    initBar();
    initSuggest();
  }

  init();
  /* Tema düzenleyicisi bölümü yeniden çizince sayaç yeniden izlenir */
  document.addEventListener('shopify:section:load', init);
})();
